import axios from "axios";
import { createHeadersAdmin } from "../../utils/Utils";
import { BASE_URL } from "../../assets/constants/constants";

//! dashboard
//  Dashboard
export const createMenuAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}create-menu`, data, headers);
};
export const updateMenuAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-menu`, data, headers);
};
export const updateMenuStatusAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-menu-status`, data, headers);
};
export const updateMgmntDirStatusAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(
    `${BASE_URL()}update-mange-directory-status`,
    data,
    headers
  );
};
export const deleteMgmntDirStatusAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(
    `${BASE_URL}delete-mange-directory`,
    data,
    headers
  );
};
export const updateOrgStrStatusAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(
    `${BASE_URL()}update-organizational-status`,
    data,
    headers
  );
};
export const updateNewsStatusAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-news-status`, data, headers);
};
export const updateImgUploadStatusAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}update-pages-status`, data, headers);
};
export const getMenuListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-menu-data`, data, headers);
};
